import { FundingOpportunities } from '@platform/client';
import { DatePickerWithTimezone, Input, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

interface CreateFundingOpportunityModalProps {
  isOpen: boolean;
  onClose: () => void;
  resetPagination: () => void;
  limit: number;
}

export const CreateFundingOpportunityModal = (props: CreateFundingOpportunityModalProps) => {
  const { isOpen, onClose, resetPagination, limit } = props;

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState(new Date());
  const [link, setLink] = useState('');

  const queryClient = useQueryClient();

  const submitFundingOpportunity = FundingOpportunities.useCreateFundingOpportunity({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            ...FundingOpportunities.getGetFundingOpportunitiesAdminQueryKey({ page: 0, limit }),
          ],
        });
        resetPagination();
      },
    },
  });

  const createFundingOpportunity = async () => {
    submitFundingOpportunity.mutate({
      data: {
        title,
        description,
        date: date.toISOString(),
        link,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
    setTitle('');
    setDescription('');
    setDate(new Date());
    setLink('');
  };

  return (
    <Modal
      variant='dialog'
      title='Create Funding Opportunity'
      isOpen={isOpen}
      headerDivision='divider'
      ignoreExtraPadding={true}
      onClose={closeModal}
      primaryCTA={{
        text: 'Create Funding Opportunity',
        callback: createFundingOpportunity,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          <Input
            label='Title'
            type='inline'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Input
            label='Description'
            type='multiline'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Input
            label='Link'
            type='inline'
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
          <DatePickerWithTimezone date={date} setDate={(newDate) => setDate(newDate)} />
        </div>
      </div>
    </Modal>
  );
};
